const currency = new Intl.NumberFormat('pt-BR', {
  currency: 'BRL',
  maximumFractionDigits: 0,
  style: 'currency',
});

export const money = (value) => currency.format(Number(value || 0));

export const getTagKind = (text) => {
  if (/pend|cancel|desativ|erro|bloque|expir/i.test(text)) return 'critical';
  if (/process|foto|aguard|convite|análise|analise/i.test(text)) return 'warning';
  if (/ativo|anunciado|confirmad|aceit|publicado|autoriz/i.test(text)) {
    return 'success';
  }
  return 'default';
};

export const propertySectionFromPath = (pathname) => {
  const parts = pathname.split('/').filter(Boolean);
  return parts[2] || 'summary';
};

export const statusFromPath = (pathname, fallback = 'all') => {
  const parts = pathname.split('/').filter(Boolean);
  const value = parts[1] || fallback;
  if (/anunciado|published/i.test(value)) return 'published';
  if (/pend|pending/i.test(value)) return 'pending';
  if (/process/i.test(value)) return 'processing';
  if (/desativ|unpublished/i.test(value)) return 'unpublished';
  if (/erro|error/i.test(value)) return 'error';
  return 'all';
};

export const titleForPath = (pathname, params = {}) => {
  if (pathname === '/portfolio-manager') {
    return ['Boas-vindas à carteira de Imobiliária Demo', 'Acompanhe aqui o status dos seus imóveis no QuintoAndar'];
  }
  if (pathname.startsWith('/status')) {
    return ['Meus imóveis', 'Após o envio, o imóvel pode levar entre 24 e 48h para ser refletido em seus imóveis no Marketplace QuintoAndar.'];
  }
  if (pathname.startsWith('/house-registration')) return ['Cadastro de imóvel', 'Cadastro do Imóvel'];
  if (pathname.startsWith('/visits')) return ['Visitas', 'Quando você tiver visitas, elas aparecerão aqui para que você possa acompanhar.'];
  if (pathname.startsWith('/property')) return ['Detalhe do imóvel', `Imóvel ${params.propertyId || '1001'}`];
  if (pathname.startsWith('/search')) return ['Resultados da busca', 'Busca por endereço ou código'];
  if (pathname.startsWith('/rent-offers')) return ['Propostas', 'As propostas listadas são apenas de imóveis anunciados para aluguel.'];
  if (pathname.startsWith('/sale-offers')) return ['Propostas de venda', 'Propostas recebidas nos últimos 180 dias.'];
  if (pathname.startsWith('/listing-performance')) return ['Performance do anúncio', 'Indicadores de visualizações, visitas e propostas.'];
  if (pathname.startsWith('/price-calculator') || pathname.startsWith('/pricing-report')) {
    return ['Calculadora de Imóveis', 'Descubra o valor correto para o imóvel'];
  }
  if (pathname.startsWith('/company-profile')) return ['Perfil da Imobiliária', 'Dados cadastrais e contato principal'];
  if (pathname.startsWith('/members')) return ['Membros', 'Convites, perfis e permissões'];
  if (pathname.startsWith('/operation-areas')) return ['Áreas de atuação', 'Defina as áreas de atuação da imobiliária'];
  if (pathname.startsWith('/integration')) return ['Integração com a Imovelweb', 'Prévia da Integração e filtros de publicação'];
  if (pathname.startsWith('/lead-') || params.leadUuid) return ['Detalhe do lead', 'Página de acompanhamento recuperada'];
  return ['Central da Imobiliária', 'Portfolio Manager'];
};
